import styled from 'styled-components';

import { rubikTypographyStyles } from '../../../../shared/ui';

export type RaffleTicketBreakdownImage = {
  alt: string;
  src: string;
};

export type RaffleTicketBreakdownSectionProps = {
  className?: string;
  diagramImage: RaffleTicketBreakdownImage;
  headline: string;
  headlineAccent?: string;
  hideTotalCard?: boolean;
  subtitle: string;
  totalTickets: string;
};

const Section = styled.section.attrs({
  'data-ui': 'raffle-ticket-breakdown-section',
})`
  ${rubikTypographyStyles};
  display: grid;
  gap: ${({ theme }) => theme.scale.px(10)};
`;

const Headline = styled.h2`
  margin: 0;
  text-align: center;
  display: grid;
  font-size: ${({ theme }) => theme.scale.px(26)};
  font-weight: 700;
  line-height: ${({ theme }) => theme.scale.px(29)};
`;

const HeadlineAccent = styled.span`
  color: ${({ theme }) => theme.colors.brand.primary};
`;

const Subtitle = styled.p`
  margin: 0;
  text-align: center;
  font-size: ${({ theme }) => theme.scale.px(15)};
  line-height: ${({ theme }) => theme.scale.px(18)};
  color: ${({ theme }) => theme.colors.text.subdued};
`;

const DiagramImage = styled.img`
  display: block;
  width: 100%;
  max-width: ${({ theme }) => theme.scale.px(355)};
  height: auto;
  margin: 0 auto;
`;

const TotalCard = styled.div`
  margin: 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: ${({ theme }) => theme.scale.px(44)};
  padding: 0 ${({ theme }) => theme.scale.px(18)};
  border-radius: ${({ theme }) => theme.scale.px(999)};
  background: ${({ theme }) => theme.colors.brand.primary};
  font-size: ${({ theme }) => theme.scale.px(15)};
  font-weight: 700;
  line-height: ${({ theme }) => theme.scale.px(18)};
`;

export function RaffleTicketBreakdownSection({
  className,
  diagramImage,
  headline,
  headlineAccent,
  hideTotalCard = false,
  subtitle,
  totalTickets,
}: RaffleTicketBreakdownSectionProps) {
  return (
    <Section className={className}>
      <Headline>
        <span>{headline}</span>
        {headlineAccent ? (
          <HeadlineAccent>{headlineAccent}</HeadlineAccent>
        ) : null}
      </Headline>
      <Subtitle>{subtitle}</Subtitle>
      <DiagramImage alt={diagramImage.alt} src={diagramImage.src} />
      {hideTotalCard ? null : <TotalCard>{totalTickets}</TotalCard>}
    </Section>
  );
}
